import queryString from "query-string";

const ALLOWED_SEARCH_FIELDS = new Set([4, 5, 6, 8, 10, 14, 15, 16, 18, 19, 22, 23, 24, 26, 30, 50]);
const ALLOWED_CONTAINS = new Set([1, 2, 3]);

const normalizeKeyword = (value) => {
    if (Array.isArray(value)) {
        return normalizeKeyword(value[0]);
    }

    if (typeof value !== "string") {
        return "";
    }

    return value.trim().slice(0, 200);
};

const parseSearchFields = (value) => {
    const raw = Array.isArray(value) ? value[0] : value;
    if (typeof raw !== "string" || raw === "") {
        return [];
    }

    try {
        const parsed = JSON.parse(raw);
        if (!Array.isArray(parsed)) {
            return [];
        }

        return parsed
            .map((item) => {
                if (!item || typeof item !== "object") {
                    return null;
                }

                const field = Number(item.field);
                if (!ALLOWED_SEARCH_FIELDS.has(field)) {
                    return null;
                }

                const contains = ALLOWED_CONTAINS.has(Number(item.contains)) ? Number(item.contains) : 1;
                const fieldText = typeof item.field_text === "string" ? item.field_text.trim().slice(0, 300) : "";
                if (fieldText === "") {
                    return null;
                }

                return {
                    field,
                    contains,
                    field_text: fieldText,
                };
            })
            .filter(Boolean)
            .slice(0, 20);
    } catch (error) {
        return [];
    }
};

export const sanitizeSearchQuery = (search) => {
    const queryParams = queryString.parse(search);
    const keyword = normalizeKeyword(queryParams.keyword);
    const searchFields = parseSearchFields(queryParams.search_fields);
    const canonicalQuery = `?${queryString.stringify({
        keyword,
        search_fields: JSON.stringify(searchFields),
    })}`;

    return { keyword, searchFields, canonicalQuery };
};
